export default "__VITE_ASSET__CsWgW5ad__";